import { NavigationContext } from '@wix/gg-components/orchestrator';
import { BI_CONSTANTS } from '../hooks/biLogger/biConstants';
import { biLogger } from '../hooks';
import { useAppStore } from 'stores/appStore';

export const categoryNextAction = async (context: NavigationContext) => {
  const { selectedCategory } = useAppStore.getState();

  biLogger.actionClicked({
    action: BI_CONSTANTS.ACTION.CATEGORY_PAGE_NEXT,
    button_name: BI_CONSTANTS.BUTTON_NAME.NEXT,
    value: selectedCategory ?? undefined,
  });
};
